'use strict';

var _throttle = require('./throttle');

var _throttle2 = _interopRequireDefault(_throttle);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

document.addEventListener('DOMContentLoaded', function () {

  var images = document.querySelectorAll('figure img.nx--lazyload');
  var offsets = [];
  var threshold = 250;

  // replacement for jQuery offset
  var offset = function offset(node, value) {
    // if the node has an offsetParent that isn't the body...
    if (node.offsetParent != document.body) {
      // add the node's offsetTop to the value.
      value += node.offsetTop;
      // call the function again, passing the node's offsetParent and the running value.
      return offset(node.offsetParent, value);
    } else {
      // if the node is relative to the body, add the offsetTop and return.
      return value += node.offsetTop;
    }
  };

  // get all the offsets
  function setOffsets() {
    images.forEach(function (img) {
      var totalOffset = 0;
      totalOffset = offset(img, totalOffset);
      offsets.push(totalOffset);
    });
  }

  setOffsets();

  window.addEventListener('resize', setOffsets);
  window.addEventListener('scroll', (0, _throttle2.default)(lazyload, 100));

  function lazyload() {
    images.forEach(function (image, index) {
      if (offsets[index] - (window.pageYOffset + window.innerHeight) <= threshold && !image.classList.contains('is-lazyloaded')) {

        var src = image.dataset.src;
        image.setAttribute('src', src);
        image.classList.add('is-lazyloaded');
      }
    });
  }
});


//////////////////
// WEBPACK FOOTER
// ./_js/backupLazyLoader.js
// module id = 23
// module chunks = 0